<div id="familiarabilities-height" class="attributeBox">
    <header class="sectionHeader box-header">Familiar Abilities</header>
    <!--Feat choices-->
    <app-featchoice class="newrow" [creature]="creatureTypesEnum.Familiar" [choice]="familiar.abilities"
        [levelNumber]="character.level" [showTitle]="true" [showContent]="true" [showChoice]="''" [showFeat]="''">
    </app-featchoice>
</div>
